import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M24,11.2c0,0.5,0,1,0,1.5c0,0.3-0.1,0.6-0.1,0.9c-0.3,2.4-1.3,4.5-2.9,6.3c-1.9,2.1-4.1,3.4-6.9,3.9
            c-0.4,0.1-0.9,0.1-1.3,0.2c-0.5,0-1,0-1.5,0c-0.3,0-0.6-0.1-0.9-0.1C8,23.5,5.9,22.6,4.1,21c-2.1-1.9-3.4-4.2-3.9-6.9
            c-0.1-0.4-0.1-0.9-0.2-1.3c0-0.5,0-1,0-1.5c0-0.3,0.1-0.6,0.1-0.9c0.4-2.6,1.5-4.9,3.3-6.8c1.8-1.8,4-3,6.5-3.4
            c0.4-0.1,0.9-0.1,1.3-0.2c0.5,0,1,0,1.5,0c0.1,0,0.3,0,0.5,0.1c2.4,0.3,4.5,1.1,6.4,2.6c2.3,1.9,3.7,4.3,4.3,7.2
            C23.9,10.4,23.9,10.8,24,11.2z"
        />
        <g>
          <path
            className="st0"
            fill="#fff"
            d="M13.7,6.6c-0.1,2.2-0.3,4.4-0.4,6.5c0,0.3,0,0.6,0,0.9c-0.1,0.6-0.6,1.1-1.2,1.1c-0.6,0-1.2-0.4-1.2-1.1
                c-0.1-0.8-0.1-1.7-0.2-2.5c-0.1-1.6-0.2-3.1-0.3-4.7c0-0.5,0-0.9,0.2-1.3c0.3-0.7,1-1.1,1.7-1s1.3,0.7,1.4,1.5
                C13.7,6.2,13.7,6.5,13.7,6.6z"
          />
          <path
            className="st0"
            fill="#fff"
            d="M13.7,18c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.8-1.6-1.7c0-0.9,0.8-1.7,1.7-1.7C13,16.2,13.7,17,13.7,18z"
          />
        </g>
      </g>
    </svg>
  )
}

type ErrorRoundedIconProps = SvgIconProps

export const ErrorRoundedIcon: React.FC<ErrorRoundedIconProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 24.632 22" focusable="false" aria-hidden="true" />
}
